var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49333 4.6498C9.49333 4.31843 9.76196 4.0498 10.0933 4.0498H11.1503C13.6034 4.0498 15.6003 6.05514 15.6003 8.49981C15.6003 10.9529 13.595 12.9498 11.1503 12.9498H10.0933C9.76196 12.9498 9.49333 12.6812 9.49333 12.3498C9.49333 12.0184 9.76196 11.7498 10.0933 11.7498H11.1503C12.9337 11.7498 14.4003 10.2887 14.4003 8.49981C14.4003 6.71647 12.9393 5.2498 11.1503 5.2498H10.0933C9.76196 5.2498 9.49333 4.98118 9.49333 4.6498ZM0.400391 8.49983C0.400391 6.04746 2.39802 4.04983 4.85039 4.04983H5.90039C6.23176 4.04983 6.50039 4.31846 6.50039 4.64983C6.50039 4.9812 6.23176 5.24983 5.90039 5.24983H4.85039C3.06076 5.24983 1.60039 6.7102 1.60039 8.49983C1.60039 10.2832 3.06147 11.7498 4.85039 11.7498H5.90039C6.23176 11.7498 6.50039 12.0185 6.50039 12.3498C6.50039 12.6812 6.23176 12.9498 5.90039 12.9498H4.85039C2.39731 12.9498 0.400391 10.9445 0.400391 8.49983ZM4.60039 8.49981C4.60039 8.16844 4.86902 7.89981 5.20039 7.89981H10.8004C11.1318 7.89981 11.4004 8.16844 11.4004 8.49981C11.4004 8.83118 11.1318 9.09981 10.8004 9.09981H5.20039C4.86902 9.09981 4.60039 8.83118 4.60039 8.49981Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEntity);
export default __webpack_public_path__ + "static/media/shareEntity.90d0f3daf6a93118e478f9aacb521357.svg";
export { ForwardRef as ReactComponent };